// removed by extract-text-webpack-plugin
module.exports = {"blogPost":"_1aqT1dadfAOKxI0iPULsEX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/post-body/PostBody.css
// module id = 552
// module chunks = 0